import { render } from "./ProfileEditInformationContent.vue?vue&type=template&id=206f673d&scoped=true"
import script from "./ProfileEditInformationContent.vue?vue&type=script&lang=js"
export * from "./ProfileEditInformationContent.vue?vue&type=script&lang=js"

import "./ProfileEditInformationContent.vue?vue&type=style&index=0&id=206f673d&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206f673d"]])

export default __exports__